import React from "react";
import { Container, IconTextWrapper, Text } from "./styles/undoredo";
import { useTranslation } from "react-i18next";
import { Redo, Undo } from "./SVG";

function UndoRedo({
  onUndo = () => {},
  onRedo = () => {},
  canUndo = false,
  canRedo = false,
}) {
  const { t } = useTranslation();

  return (
    <Container>
      <IconTextWrapper
        isDisabled={!canUndo}
        onClick={canUndo ? onUndo : () => {}}
      >
        <Undo />
        <Text>{t("undo")}</Text>
      </IconTextWrapper>
      <IconTextWrapper
        isDisabled={!canRedo}
        onClick={canRedo ? onRedo : () => {}}
      >
        <Redo />
        <Text>{t("redo")}</Text>
      </IconTextWrapper>
    </Container>
  );
}

export default UndoRedo;
